import { Numbers } from '@mui/icons-material'
import { Stack, Typography } from '@mui/material'
import { TruckVisitWithOrdersDto } from '@planning/app/api'
import { CustomAlert } from '@planning/index'
import { useTranslate } from '@tolgee/react'
import { observer } from 'mobx-react-lite'
import { TruckVisitDriver } from '../Atoms/TruckVisitDriver'
import { TruckVisitExpectedArrival } from '../Atoms/TruckVisitExpectedArrival'

interface Props {
  truckVisit: TruckVisitWithOrdersDto
}
export const TruckVisitDetails = observer(({ truckVisit }: Props) => {
  const { t } = useTranslate()

  return (
    <Stack gap={1}>
      <TruckVisitDriver truckVisit={truckVisit} />
      {truckVisit.driver?.banned && (
        <CustomAlert
          message={t(
            'cateInIsBlockedDueToExternalDriverBanned',
            'Gate in is blocked due to the external driver being banned.',
          )}
          severity='warning'
        />
      )}
      <TruckVisitExpectedArrival
        truckVisit={truckVisit}
        label={t('expectedArrivalWindow', 'Expected arrival window')}
      />
      {truckVisit.externalPortGatePassRef && (
        <Stack direction={'row'} spacing={1} alignItems={'center'}>
          <Numbers />
          <Stack>
            <Typography variant='caption' color='secondary'>
              {t('externalRefGatePassNo', 'External ref/Gate pass no.')}
            </Typography>
            <Typography variant='body2'>{truckVisit.externalPortGatePassRef}</Typography>
          </Stack>
        </Stack>
      )}
    </Stack>
  )
})
